import { render, staticRenderFns } from "./buyerTemplates.vue?vue&type=template&id=589ed28f&scoped=true"
import script from "./buyerTemplates.vue?vue&type=script&lang=js"
export * from "./buyerTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ed28f",
  null
  
)

export default component.exports